/* E-Kinderauto Theme – Warenkorb, Varianten, Navigation */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, strings: {}, money: { format: '{{amount}} €' } };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var value = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = T.money.format || '{{amount}} €';
    return fmt.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, value).replace(/<[^>]+>/g, '');
  }

  var toastTimer;
  function toast(html) {
    var el = $('#toast'); if (!el) return;
    el.innerHTML = html; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 4000);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
  }

  /* ---------- Warenkorb: Hinzufügen per AJAX ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.querySelector('[data-btn-label]') : null;
    var original = label ? label.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); if (label) label.textContent = '…'; }
    var fd = new FormData(form);
    fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || T.strings.error);
        return fetch(T.routes.cartJson).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function (err) { toast('<span>' + (err.message || T.strings.error) + '</span>'); })
      .then(function () { if (btn) { btn.removeAttribute('aria-disabled'); if (label) label.textContent = original; } });
  });

  /* ---------- Warenkorb-Drawer ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  function cartOpen() { if (cartDrawer) { cartDrawer.hidden = false; document.body.style.overflow = 'hidden'; } }
  function cartClose() { if (cartDrawer) { cartDrawer.hidden = true; document.body.style.overflow = ''; } }
  function thumb(url) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
  function variantLabel(it) { var t = it.variant_title; if (!t || t === 'Default Title' || t === 'Standard') return ''; return t; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fetchCart() { return fetch(T.routes.cartJson, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeByKey(key, qty) { return fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); }); }
  function renderCart(cart) {
    if (!cartDrawer) return;
    updateCartCount(cart.item_count);
    var body = $('[data-cart-body]', cartDrawer), empty = $('[data-cart-empty]', cartDrawer), foot = $('[data-cart-foot]', cartDrawer), cl = $('[data-cart-count-label]', cartDrawer);
    if (cl) cl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.items || !cart.items.length) { if (body) body.innerHTML = ''; if (empty) empty.hidden = false; if (foot) foot.hidden = true; return; }
    if (empty) empty.hidden = true; if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map(function (it) {
      var vl = variantLabel(it);
      return '<li class="cartd__line" data-key="' + it.key + '">' +
        (it.image ? '<img class="cartd__line-img" src="' + thumb(it.image) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="cartd__line-img"></span>') +
        '<div class="cartd__line-main">' +
          '<div class="cartd__line-top">' +
            '<a class="cartd__line-title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
            '<button type="button" class="cartd__line-x" data-cart-remove aria-label="' + (T.strings.remove || 'Entfernen') + '">&times;</button>' +
          '</div>' +
          (vl ? '<span class="cartd__line-variant">' + esc(vl) + '</span>' : '') +
          '<div class="cartd__line-bottom">' +
            '<span class="cartd__line-qty"><button type="button" data-cart-minus aria-label="minus">–</button><span>' + it.quantity + '</span><button type="button" data-cart-plus aria-label="plus">+</button></span>' +
            '<span class="cartd__line-price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('');
    var sub = $('[data-cart-subtotal]', cartDrawer);
    if (sub) sub.textContent = money(cart.total_price);
  }
  document.addEventListener('cart:updated', function (e) { renderCart(e.detail); cartOpen(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cartDrawer && !cartDrawer.hidden) cartClose(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); fetchCart().then(function (c) { renderCart(c); cartOpen(); }); return; }
    if (e.target.closest('[data-cart-close]')) { cartClose(); return; }
    var line = e.target.closest('.cartd__line');
    if (line && cartDrawer && !cartDrawer.hidden) {
      var key = line.dataset.key, qSpan = line.querySelector('.cartd__line-qty span'), q = qSpan ? Number(qSpan.textContent) : 1;
      if (e.target.closest('[data-cart-plus]')) changeByKey(key, q + 1).then(renderCart);
      else if (e.target.closest('[data-cart-minus]')) changeByKey(key, Math.max(0, q - 1)).then(renderCart);
      else if (e.target.closest('[data-cart-remove]')) changeByKey(key, 0).then(renderCart);
    }
  });

  /* ---------- Direkt kaufen: hinzufügen und direkt zur Kasse ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-buy-now]'); if (!b || b.hasAttribute('disabled')) return;
    e.preventDefault();
    var form = b.closest('form'); if (!form) return;
    var idEl = form.querySelector('[name="id"]'), qEl = form.querySelector('[name="quantity"]');
    var id = idEl ? Number(idEl.value) : 0, qty = qEl ? Number(qEl.value) || 1 : 1;
    if (!id) return;
    b.setAttribute('aria-disabled', 'true');
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw 0; window.location.href = '/checkout'; })
      .catch(function () { b.removeAttribute('aria-disabled'); toast('<span>' + T.strings.error + '</span>'); });
  });

  /* ---------- Warenkorb-Seite: Menge ändern / entfernen ---------- */
  function changeLine(line, quantity) {
    return fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
      .then(function (r) { return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    changeLine(Number(btn.dataset.lineRemove), 0).then(function () { location.reload(); });
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('[data-line-qty]')) return;
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(Number(input.dataset.lineQty), q).then(function () { location.reload(); });
  });

  /* ---------- Mengen-Stepper ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep);
    var min = parseInt(input.min, 10) || 1; var max = parseInt(input.max, 10) || 99;
    input.value = Math.min(max, Math.max(min, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variantenwahl auf der Produktseite ---------- */
  function initVariants(root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('form[data-ajax-cart]', root);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = $('[data-price]', root), compareEl = $('[data-compare-price]', root), saveEl = $('[data-price-save]', root), uvpEl = $('[data-compare-label]', root);
    var btn = form ? form.querySelector('[type="submit"]') : null;
    var stockEl = $('[data-stock]', root);
    var gallery = $('[data-gallery]', root);

    function selectedOptions() {
      return $$('[data-option-index]', root).map(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) return checked.value;
        var sel = group.querySelector('select');
        return sel ? sel.value : null;
      });
    }
    function findVariant(opts) {
      // Ohne Auswahlfelder (Einzelvariante / Default-Variante): die aktuell gesetzte bzw. erste Variante nehmen
      if (!opts.length) {
        var cur = idInput ? Number(idInput.value) : 0;
        return product.variants.filter(function (v) { return v.id === cur; })[0] || product.variants[0] || null;
      }
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
    }
    function showImage(variant) {
      if (!gallery || !variant || !variant.featured_media) return;
      var target = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (target) { var thumb = gallery.querySelector('[data-thumb-for="' + variant.featured_media.id + '"]'); if (thumb) thumb.click(); else target.scrollIntoView({ block: 'nearest' }); }
    }
    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      $$('[data-option-index] input', root).forEach(function (input) { var label = input.closest('label'); if (label) label.classList.toggle('is-selected', input.checked); });
      var label = btn ? btn.querySelector('[data-btn-label]') : null;
      var buynow = root.querySelector('[data-buy-now]');
      if (!v) {
        if (btn) { btn.setAttribute('disabled', ''); if (label) label.textContent = T.strings.unavailable; }
        if (buynow) buynow.setAttribute('disabled', '');
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { var pct = v.compare_at_price > v.price ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0; if (pct >= 5) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; if (uvpEl) uvpEl.hidden = false; if (saveEl) { saveEl.textContent = '−' + pct + ' %'; saveEl.hidden = false; } } else { compareEl.hidden = true; if (uvpEl) uvpEl.hidden = true; if (saveEl) saveEl.hidden = true; } }
      if (btn) { if (v.available) { btn.removeAttribute('disabled'); if (label) label.textContent = T.strings.addToCart; } else { btn.setAttribute('disabled', ''); if (label) label.textContent = T.strings.soldOut; } }
      if (buynow) { if (v.available) buynow.removeAttribute('disabled'); else buynow.setAttribute('disabled', ''); }
      if (stockEl) { stockEl.innerHTML = v.available ? stockEl.dataset.available : stockEl.dataset.soldout; }
      showImage(v);
      if (history.replaceState) { var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); }
    }
    $$('[data-option-index] input, [data-option-index] select', root).forEach(function (el) { el.addEventListener('change', update); });
    update();
  }

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    var gallery = $('[data-gallery]', root); if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    $$('[data-thumb-for]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.dataset.thumbFor;
        $$('[data-media-id]', main).forEach(function (m) { m.hidden = m.dataset.mediaId !== id; });
        $$('[data-thumb-for]', gallery).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }

  /* ---------- Mobile Navigation ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]'); if (open) { var d = $('#' + open.dataset.drawerOpen); if (d && d.showModal) d.showModal(); }
    var close = e.target.closest('[data-drawer-close]'); if (close) { var dc = close.closest('dialog'); if (dc) dc.close(); }
  });
  document.addEventListener('click', function (e) {
    var d = e.target; if (d.tagName === 'DIALOG' && d.classList.contains('drawer')) { var r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close(); }
  });
  /* Desktop-Dropdowns schließen, wenn woanders geklickt wird */
  document.addEventListener('click', function (e) {
    $$('.site-nav details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-product-root]').forEach(function (root) { initGallery(root); initVariants(root); });
  });
})();

// Mobile Kaufleiste auf der Produktseite: erscheint, sobald der Warenkorb-Button aus dem Bild ist
(function () {
  var bar = document.querySelector('[data-sticky-bar]'); var add = document.querySelector('.product__add');
  if (!bar || !add || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) { bar.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top < 0 === false && entries[0].isIntersecting; bar.hidden = entries[0].isIntersecting; }, { threshold: 0 }).observe(add);
  var stickyAdd = bar.querySelector('[data-sticky-add]'); if (stickyAdd) stickyAdd.addEventListener('click', function () { add.click(); });
  var price = document.querySelector('[data-price]'), sp = bar.querySelector('[data-sticky-price]');
  if (price && sp) new MutationObserver(function () { sp.textContent = price.textContent; if (stickyAdd) { stickyAdd.disabled = add.disabled; stickyAdd.textContent = add.textContent.trim(); } }).observe(price, { childList: true, characterData: true, subtree: true });
})();

// Newsletter-Popup (mittiges Modal): nach Verzögerung einblenden, Schließen für X Tage merken
(function () {
  var modal = document.querySelector('[data-nl-card]'); if (!modal) return;
  var key = 'nlCardClosed', days = Number(modal.dataset.days || 30), delay = Number(modal.dataset.delay || 15) * 1000;
  function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
  function close() { modal.hidden = true; document.body.style.overflow = ''; try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
  // Schließen per X-Button oder Klick auf den Hintergrund sowie per Esc
  modal.querySelectorAll('[data-nl-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  // Gutscheincode kopieren
  var copyBtn = modal.querySelector('[data-nl-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var code = copyBtn.getAttribute('data-nl-copy');
    function done() { copyBtn.classList.add('is-copied'); copyBtn.textContent = 'Kopiert!'; }
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); return; }
    var el = modal.querySelector('[data-nl-code]');
    if (el) { var r = document.createRange(); r.selectNodeContents(el); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); try { document.execCommand('copy'); } catch (e2) {} }
    done();
  });
  var posted = !!modal.querySelector('.nl-modal__ok');
  if (posted) { open(); return; }
  var closedAt = 0; try { closedAt = Number(localStorage.getItem(key) || 0); } catch (e) {}
  if (closedAt && Date.now() - closedAt < days * 864e5) return;
  // erst zeigen, wenn das Cookie-Banner von Shopify weg ist
  function bannerOpen() { var b = document.querySelector('#shopify-pc__banner'); return !!(b && b.offsetParent !== null); }
  function show() { if (bannerOpen()) { setTimeout(show, 2000); return; } open(); }
  setTimeout(show, delay);
})();
